import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-heading text-3xl md:text-4xl tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="text-ink2 text-sm mt-1 font-body max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Section({ children, title, description, actions, className = "" }) {
  return (
    <section className={`bg-surface border border-line rounded-sm ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-line">
          <div>
            {title && <h2 className="font-heading text-lg text-ink">{title}</h2>}
            {description && <p className="text-xs text-ink2 mt-0.5">{description}</p>}
          </div>
          {actions}
        </div>
      )}
      <div>{children}</div>
    </section>
  );
}

export function Pill({ children, tone = "default", testid }) {
  const tones = {
    default: "bg-sidebar text-ink",
    brand: "bg-brand/10 text-brand border border-brand/20",
    success: "bg-olive/10 text-olive border border-olive/20",
    warning: "bg-amber/15 text-amber border border-amber/30",
    danger: "bg-crimson/10 text-crimson border border-crimson/20",
    muted: "bg-sidebar text-ink2",
  };
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] uppercase tracking-[0.1em] font-medium ${tones[tone] || tones.default}`}>
      {children}
    </span>
  );
}

export function EmptyState({ title, description, action, testid }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid={testid}>
      <div className="font-heading text-xl text-ink">{title}</div>
      {description && <div className="text-sm text-ink2 mt-2 max-w-md">{description}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
